import AppSettings from "../../../../Settings/AppSettings";
import React, { useContext, useEffect, useState } from "react";
import { CategoryContext } from "../CategoryContext";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import EditCategoryAttributes from "./EditCategoryAttributes";
import Label from "../../../Common/components/Label";
import SmallFillButton from "../../../Common/components/SmallFillButton";
import SmallOutlinedButton from "../../../Common/components/SmallOutlinedButton";
import { toast } from "react-toastify";
import { AppContext } from "../../../../Context/AppContext";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";

const ConstraintsItem = ({ label, value }) => {
  return (
    <div className="col-6">
      <div className="">
        {/* <Label message={value} fontSize={0.8} /> */}
        <li>
          <span className={"ms-2"}>
            {/* <strong>{value}: </strong> */}
            <Label
              message={`${label}:`}
              fontWeight="500"
              fontFamily="Noto Sans"
            />
          </span>
          &nbsp;
          <br />
          <span className={"ms-2"}>
            <Label
              message={`${value}`}
              fontWeight="500"
              color="#A1A1A1"
              fontFamily="Noto Sans"
            />
            {/* {`${value}`} */}
          </span>
        </li>
      </div>
    </div>
  );
};

const CategoryAttributeConstraint = () => {
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const { editingItem } = useContext(CategoryContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });
  const appData = useContext(AppContext);
  const [list, setList] = useState(null);
  const [EditConstraint, setEditConstraint] = useState(false);
  const [categoryAttributes, setCategoryAttributes] = useState(null);
  //const [item, setItem] = useState(false);
  const [categoryId, setCategoryId] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [collapse, setCollapse] = useState(false);
  let [consAttribute, setConsAttribute] = useState(null);

  useEffect(() => {
    setConsAttribute(null);
    setLoading({
      status: "",
      message: "",
    });
  }, [editingItem.id]);

  useEffect(() => {
    if (list === null && collapse) {
      load_associated_Abs_attributes();
    }
  }, [collapse]);

  useEffect(() => {
    if (EditConstraint) {
      load_associated_Abs_attributes();
    }
  }, [EditConstraint]);

  async function load_associated_Abs_attributes(message) {
    setLoading({
      status: "Loading",
      message: `${
        message === undefined
          ? "Loading Category Attribute Constraints"
          : message
      }`,
    });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}attribute/getconstraintsbycategoryid/${editingItem.id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      setTimeout(
        () => {
          setLoading({ status: "Success", message: undefined });
        },
        message === undefined ? 0 : 1000
      );

      setConsAttribute(res.data.data);
      setList(res.data.data);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
  }

  async function handle_save() {
    setLoading({
      status: "Loading",
      message: "Saving updated Category Attributes",
    });
    categoryAttributes.validation_type = "LOV";
    if (categoryAttributes.validation_type === "") {
      categoryAttributes.validation_type = "LOV";
    }
    if (categoryAttributes.datatype === "") {
      categoryAttributes.datatype = "INTEGER";
    }
    let res = await ServiceWrapper.doPost(
      `${api_base_url}category/${editingItem.id}/attribute/${categoryId}/constraints/edit`,
      // object to be sent,
      categoryAttributes,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({
          status: "Success",
          message: res.data.message,
        });
        load_associated_Abs_attributes(res.data.message);
      } else {
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      setLoading({
        status: "Error",
        message: "Error while saving, Please try after some time.",
      });
    }
    setEditConstraint(false);
  }

  function handle_cancel() {
    setEditConstraint(false);
    setList(consAttribute);
  }

  return (
    <>
      <div className="accordion" id="accordionFlushConstraint">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed shadow-none"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseConstraint"
            aria-expanded="false"
            aria-controls="flush-collapseConstraint"
            // style={Utils.borderStyle()}
            style={{
              height: "2.6875rem",
              border: "1px solid #c9cccf",
            }}
          >
            <div>
              {EditConstraint ? <Label message="Update " /> : ""}{" "}
              <Label
                message={`${
                  EditConstraint
                    ? categoryName + "  constraints"
                    : "Category Attribute Constraints"
                }`}
              />{" "}
            </div>
          </div>

          {collapse && (
            <>
              {loading.status === "Success" && (
                <>
                  {!EditConstraint ? (
                    <div
                      className="d-inline-block float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      <button
                        type="button"
                        className="btn tn-sm btn-sm"
                        style={{
                          color: "#091caa",
                          background: "none",
                          border: "none",
                          boxShadow: "none",
                        }}
                        onClick={() => {
                          load_associated_Abs_attributes();
                        }}
                      >
                        <i
                          className="fa fa-sync-alt"
                          style={{ color: "#091caa", fontSize: "0.875rem" }}
                        />
                      </button>
                    </div>
                  ) : (
                    <div
                      className="d-inline-block d-flex float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      <SmallOutlinedButton
                        name="Cancel"
                        onClick={() => {
                          handle_cancel();
                        }}
                      />
                      &nbsp;
                      <SmallFillButton
                        name="Save"
                        onClick={() => handle_save()}
                      />
                    </div>
                  )}
                </>
              )}
            </>
          )}

          <div
            id="flush-collapseConstraint"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingConstraint"
            data-bs-parent="#accordionFlushConstraint"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              <LoadingSuccessErrorAlert loading={loading} />
              {loading.status === "Success" && (
                <>
                  {EditConstraint ? (
                    <div
                      className="p-3"
                      style={{
                        borderBottom: "1px solid #c9cccf",
                        borderLeft: "1px solid #c9cccf",
                        borderRight: "1px solid #c9cccf",
                        borderTop: "none",
                      }}
                    >
                      <EditCategoryAttributes
                        categoryAttributes={categoryAttributes}
                        setCategoryAttributes={setCategoryAttributes}
                      />
                    </div>
                  ) : (
                    <div
                      className="p-3"
                      style={{
                        borderBottom: "1px solid #c9cccf",
                        borderLeft: "1px solid #c9cccf",
                        borderRight: "1px solid #c9cccf",
                        borderTop: "none",
                      }}
                    >
                      <div>
                        <ul className="list-unstyled">
                          {consAttribute && consAttribute.length > 0 ? (
                            consAttribute.map((item, index) => {
                              return (
                                <div key={item.id}>
                                  <span
                                    className=" btn-toggle collapsed text-truncate ms-1 pb-3"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#categoryItem-${index}`}
                                    aria-expanded="false"
                                  />

                                  <span className="w-100">
                                    <span
                                      onClick={() => {}}
                                      style={{
                                        cursor: "pointer",
                                        wordBreak: "break-word",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      &nbsp;
                                      <span className={""}>
                                        <Label
                                          fontWeight="400"
                                          color="#5c5f62"
                                          fontFamily="Noto Sans"
                                          message={`Constraints: ${item.name}`}
                                        />
                                      </span>
                                    </span>
                                    <div
                                      className="float-end pe-3"
                                      style={{ curson: "pointer" }}
                                    >
                                      <Label
                                        message="Edit"
                                        color="#091caa"
                                        fontSize="0.750"
                                        onClick={() => {
                                          if (
                                            appData.pm.checkPermission(
                                              "gmscategory_update"
                                            )
                                          ) {
                                            setCategoryName(item.name);
                                            setCategoryId(item.id);
                                            setCategoryAttributes(
                                              item.attribute_constraints
                                            );
                                            setEditConstraint(true);
                                          } else {
                                            toast.info(
                                              "You don't have permission to edit the category constraint"
                                            );
                                          }
                                        }}
                                      />
                                    </div>
                                  </span>
                                  <div
                                    className="collapse"
                                    id={`categoryItem-${index}`}
                                  >
                                    <div
                                      className="btn-toggle-nav list-unstyled  w-100"
                                      key={index}
                                    >
                                      <div className="container overflow-hidden">
                                        <div className="row gy-3">
                                          <ConstraintsItem
                                            label="Validation "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation ?? false
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Allowed Chars "
                                            value={
                                              item?.attribute_constraints
                                                ?.allowed_chars ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Allowed User Defined Values "
                                            value={
                                              item?.attribute_constraints
                                                ?.allowed_user_defined_values ??
                                              false
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Prohibited Chars "
                                            value={
                                              item?.attribute_constraints
                                                ?.prohibited_chars ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Attr Inheritance "
                                            value={
                                              item?.attribute_constraints
                                                ?.attr_inheritance ?? false
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Multi Select"
                                            value={
                                              item?.attribute_constraints
                                                ?.multiselect ?? false
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Child Attr "
                                            value={
                                              item?.attribute_constraints
                                                ?.child_attr ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Multiselect Number "
                                            value={`${
                                              item.attribute_constraints
                                                .multiselect_number !== null
                                                ? item.attribute_constraints
                                                    .multiselect_number
                                                : "-"
                                            }`}
                                          />

                                          <ConstraintsItem
                                            label="Datatype "
                                            value={
                                              item?.attribute_constraints
                                                ?.datatype ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Multiselect Output Range "
                                            value={
                                              item?.attribute_constraints
                                                ?.multiselect_output_range ??
                                              "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Type "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_type ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Type Extra Criteria "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_type_extra_criteria ??
                                              ""
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Special Formatting "
                                            value={
                                              item?.attribute_constraints
                                                ?.special_formatting ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Extra Criteria Value 1 "
                                            value={
                                              item?.attribute_constraints
                                                ?.extra_criteria_value1 ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Range "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_range ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Extra Criteria Value 2 "
                                            value={
                                              item?.attribute_constraints
                                                ?.extra_criteria_value2 ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Error Alert Style "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_error_alert_style ??
                                              "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Input Message "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_input_message ??
                                              false
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Error Alert "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_error_alert ??
                                              false
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Error Alert Body "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_error_alert_body ??
                                              "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Error Alert Title "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_error_alert_title ??
                                              "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Input Message Title "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_input_message_title ??
                                              "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation Input Message Body "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation_input_message_body ??
                                              "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Column Order "
                                            value={
                                              item?.attribute_constraints
                                                ?.column_order ?? "-"
                                            }
                                          />

                                          <ConstraintsItem
                                            label="Validation "
                                            value={
                                              item?.attribute_constraints
                                                ?.validation ?? false
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              className="alert alert-primary p-1"
                              role="alert"
                            >
                              No categories attributes constraints found
                            </div>
                          )}
                        </ul>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryAttributeConstraint;
